export default __webpack_public_path__ + "static/media/img_calendar_tag_end.60f0ddc2.svg";